export enum GridPosition {
  Left = 'Left',
  Center = 'Center',
  Right = 'Right'
}
